/**************
 Mobile Nav
 ***************/

async function fetchSearchResults(linkUrl) {
    const parser = new DOMParser();
    // fetch recommendations and update section
    const htmlString = await fetch(linkUrl.toString())
        .then(response => response.text())
        .then(text => {
            return text
        });
    const fetchedHTML = parser.parseFromString(htmlString, "text/html");
    return fetchedHTML;
}

function buildSearchUrl() {
    let searchForm = document.querySelector("#headerIconsSearchForm")
    if (window.innerWidth <= 800) {
        searchForm = document.querySelector("#headerIconsSearchMobileForm")
    }
    const formData = new FormData(searchForm);
    const searchParams = new URLSearchParams(formData);
    return `${searchForm.action}?${searchParams}`
}

// mobile slider nested dropdown
document.querySelectorAll(".sliderNavDropdown").forEach(element => {
    const itemButton = element.querySelector(".sliderNavDropdownToggle");
    const itemDialog = element.querySelector(".sliderNavDropdownLinks");

    setupModal(itemDialog, itemButton, false, "mobileSubMenuIn", "mobileSubMenuOut");

    itemButton.addEventListener("click", function () {
        this.classList.toggle("active");
        this.setAttribute("aria-expanded", this.classList.contains("active"));
    });
});


document.querySelectorAll(".sliderNavDropdownToggle").forEach(button => {
    button.addEventListener("click", function (e) {
        document.querySelectorAll(".sliderNavDropdownToggle").forEach(otherButton => {
            if (e.target !== otherButton) {
                console.log(otherButton.parentNode.querySelector(".sliderNavDropdownLinks"));
                if (otherButton.parentNode.querySelector(".sliderNavDropdownLinks").open) {
                    otherButton.classList.remove("active");
                    otherButton.parentNode.querySelector(".sliderNavDropdownLinks").close();
                    otherButton.parentNode.querySelector(".sliderNavDropdownLinks").firstElementChild.classList.remove(".mobileSubMenuIn");
                    otherButton.parentNode.querySelector(".sliderNavDropdownLinks").firstElementChild.classList.remove(".mobileSubMenuOut");
                }
            }
        });
    })
});

// open nav
function openNav() {
    document.querySelector("#slider").showModal();
    document.querySelector("body").classList.add("noScroll");
}

// dialog close event
document.querySelector("#slider").addEventListener("close", async function () {
    document.querySelector("body").classList.remove("noScroll");
});

// close nav
async function closeNav() {
    document.querySelector("#slider").close();
}

// open nav event listener
document.querySelectorAll(".openNav").forEach(function (element) {
    element.addEventListener("click", openNav);
});

// close nav event listener
document.querySelectorAll(".closeNav").forEach(function (element) {
    element.addEventListener("click", closeNav);
});

// Nav item listener
document.querySelectorAll(".headerNavLinkContent").forEach((button) => {
    button.addEventListener("click", function (e) {
        // Grab this buttons associated modal
        const buttonModal = button.querySelector(".headerNavLinkContentExpanded");

        // Close all other open nav modals
        document.querySelectorAll(".headerNavLinkContentExpanded[open]").forEach((element) => {
            if (buttonModal !== element) {
                element.firstElementChild.classList.add("navModalOut");
            }
        });

        if (buttonModal) {
            if (buttonModal.open) {
                buttonModal.firstElementChild.classList.remove("navModalOut");
            }
        }
    });
});

// Setup animations for the nav modals
document.querySelectorAll(".headerNavLinkContentExpanded").forEach((element) => {
    setupModal(element, false, false, "navModalIn", "navModalOut");
});

function setLoading(status) {
    const searchModalContent = document.querySelector(".headerIconsSearchFormDropBackground");
    const searchMobileModalContent = document.querySelector(".headerIconsSearchMobileFormDropBackground");
    if (status) {
        searchModalContent.classList.add("loading");
        searchMobileModalContent.classList.add("loading");
    } else {
        searchModalContent.classList.remove("loading");
        searchMobileModalContent.classList.remove("loading");
    }
}

// Update the dropdown UI with the results of the search
// Takes in an array of objects that are product objects from shopify
function updateDropDownContent(searchResults) {
    // 1. Store the links wrapper
    let linksWrapper = document.querySelector(".headerIconsSearchFormDropContentLinksList");
    if (window.innerWidth <= 800) {
        linksWrapper = document.querySelector(".headerIconsSearchMobileFormDropContentLinksList");
    }

    // 2. loop through the results and populate the links wrapper with the product information
    // 2a. Limit the number of links that can be rendered
    let linksRange = 5;
    if (searchResults.length < linksRange) {
        linksRange = searchResults.length;
    }
    // 2b. Update the links list with the fetched results
    let linksHTML = ""
    console.log(searchResults);
    for (let i = 0; i < linksRange; i++) {
        linksHTML += `
            <li>
                <a class="headerNavLinkContentExpandedLinksItem" href="/products/${searchResults[i].handle}">
                    ${searchResults[i].title}
                </a>
            </li>
        `
    }
    linksWrapper.innerHTML = linksHTML;

    // 3. Update the links button text to show how many results are present
    document.querySelector(".headerIconsSearchFormDropContentLinksButton").textContent = `view all ${searchResults.length} results`;
    document.querySelector(".headerIconsSearchMobileFormDropContentLinksButton").textContent = `view all ${searchResults.length} results`;

    // 4. Store the featured product wrapper
    let featuredProductsWrapper = document.querySelector(".headerIconsSearchFormDropContentFeaturedList");
    if (window.innerWidth <= 800) {
        featuredProductsWrapper = document.querySelector(".headerIconsSearchMobileFormDropContentFeaturedList");
    }
    // 4b. Store the product cards in the featured wrapper
    const featuredCards = featuredProductsWrapper.querySelectorAll(".collectionItem");

    // 5. Fill each product card with the matching search result, hiding cards with no result to show
    featuredCards.forEach((card, i) => {
        if (!searchResults[i]) {
            card.classList.add("hide");
            return;
        }
        card.classList.remove("hide");
        card.href = `/products/${searchResults[i].handle}`;
        card.querySelector(".collectionItemImage").src = searchResults[i].featured_image;
        card.querySelector(".collectionItemImage").alt = `${searchResults[i].title} image`;
        card.querySelector(".collectionItemTitle").textContent = searchResults[i].title;
        card.querySelector(".collectionItemPriceValue").textContent = price(searchResults[i].price, true);
    });

    setLoading(false);
}

// Desktop header search bar drop down
const searchBarDropModal = document.querySelector(".headerIconsSearchFormDrop");
const searchBarOpenButton = document.querySelector("button.headerIconsSearch.desktop")
setupModal(searchBarDropModal, false, false, "navModalIn", "navModalOut", false, false);

// This modal is unique because we don't want the modal to steal focus away from the text box. We use and active
// class to show the modal for this one.

// Debounce or search so it's not as heavy
const optimizedSearch = debounce(async (searchValue) => {
    setLoading(true);
    // 1. Fetch our search results html
    const searchUrl = buildSearchUrl();
    document.querySelector(".headerIconsSearchFormDropContentLinksButton").href = searchUrl;
    document.querySelector(".headerIconsSearchMobileFormDropContentLinksButton").href = searchUrl;
    const searchResults = await fetchSearchResults(searchUrl);

    // 2. store the searchResults data from a querySelector
    const resultsJson = JSON.parse(searchResults.querySelector("#searchResultsJSON").textContent);

    // 3. Update the dropdown content with the data from the fetch
    updateDropDownContent(resultsJson);
}, 500);


let openStatus = false;
document.querySelector(".headerIconsSearchFormLabelInput").addEventListener("input", async function (e) {
    const searchModal = document.querySelector(".headerIconsSearchFormDrop");
    if (e.target.value !== "" && !openStatus) {
        searchModal.classList.add("active");
        searchModal.firstElementChild.classList.add("navModalIn");
        openStatus = true;
    } else if (e.target.value === "" && openStatus) {
        searchModal.firstElementChild.classList.add("navModalOut");
        openStatus = false;
    }

    if (openStatus) {
        optimizedSearch(e.target.value);
    }
});

// Separate animation listener to handle the active class on the modal (unique situation).
document.querySelector(".headerIconsSearchFormDrop").firstElementChild.addEventListener("animationend", function (e) {
    if (e.animationName === "navModalOut") {
        document.querySelector(".headerIconsSearchFormDrop").classList.remove("active");
    }
});

// SETUP THE MOBILE SEARCH SLIDER
const mobileSearchSlider = document.querySelector("#headerMobileSearchSlider");
const mobileSearchOpenButton = document.querySelector(`button[aria-controls='${mobileSearchSlider}']`);
setupModal(mobileSearchSlider, mobileSearchOpenButton, true, "modalIn", "modalOut", true, false)

document.querySelector(".headerIconsSearchMobileFormLabelInput").addEventListener("input", async function (e) {
    optimizedSearch(e.target.value);
});
